import { render, staticRenderFns } from "./mActivity.vue?vue&type=template&id=767eee72&scoped=true&"
import script from "./mActivity.vue?vue&type=script&lang=js&"
export * from "./mActivity.vue?vue&type=script&lang=js&"
import style0 from "./mActivity.vue?vue&type=style&index=0&id=767eee72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eee72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767eee72')) {
      api.createRecord('767eee72', component.options)
    } else {
      api.reload('767eee72', component.options)
    }
    module.hot.accept("./mActivity.vue?vue&type=template&id=767eee72&scoped=true&", function () {
      api.rerender('767eee72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/mActivity.vue"
export default component.exports